import styles from "./loader.module.css";

const Loader = ({ loading, loadingText = "Loading", style = {} }) => {
  if (!loading) return null;

  return (
    <div
      className={`d-flex justify-content-center align-items-center ${styles.fullscreenOverlay}`}
      style={style}
    >
      <div className="text-center">
        <div
          className={`spinner-border text-primary ${styles.spinnerLarge}`}
          role="status"
        >
          <span className="visually-hidden">{loadingText}</span>
        </div>
        <div className="mt-3">{loadingText}</div>
      </div>
    </div>
  );
};

export default Loader;
